import Modal from "common/Modal/Modal";

interface YoutubeVideoModalProps {
  open: boolean;
  closeModal: () => void;
  embedLink: string;
}

const YoutubeVideoModal = ({
  open,
  embedLink,
  closeModal,
}: YoutubeVideoModalProps) => {
  return (
    <Modal
      open={open}
      centered={true}
      width={VIDEO_WIDTH + PADDING * 2}
      onCancel={closeModal}
      closable={false}
      styles={{
        body: { padding: PADDING },
      }}
      zIndex={1002}
      destroyOnHidden={true}
    >
      <iframe
        title="YouTube"
        src={embedLink}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        style={{
          width: "100%",
          aspectRatio: `${VIDEO_WIDTH} / ${VIDEO_HEIGHT}`,
          display: "block",
          border: "none",
        }}
      />
    </Modal>
  );
};

export default YoutubeVideoModal;

const VIDEO_WIDTH = 715;
const VIDEO_HEIGHT = 411;
const PADDING = 6;
